/**
 * Author:Kani
 * Modified by:kani
 * Modified Date: 2025-05-26
 */
// PricingPlans.js
import React, { useRef, useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Label, Input, FormFeedback ,Row,Col} from "reactstrap";
import * as Yup from "yup";
import * as url from "../../../src/helpers/url_helper";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import {RAZORPAY_KEY} from '../../constants/commonVariable'
import Spinners from "../../components/Common/Spinner";
import './PricingPlans.css';
import { useNavigate, useLocation } from 'react-router-dom'

import ConfirmModal from "../../components/Common/ConfirmModal";
export default function WelcomeComp() {
   const navigate = useNavigate();
  const scrollRef = useRef();
  const [showScrollButtons, setShowScrollButtons] = useState(false);
  const [planList, setPlanList] = useState([]);
 
  const [isLoading, setLoading] = useState(false);


  
  const checkOverflow = () => {
    const el = scrollRef.current;
    if (el) {
      setShowScrollButtons(el.scrollWidth > el.clientWidth);
    }
  };
  const handleSubscribeClick = (plan) => {
    navigate('/login')
  };

  const scroll = (direction) => {
    if (scrollRef.current) {
      const { scrollLeft, clientWidth } = scrollRef.current;
      scrollRef.current.scrollTo({
        left: direction === 'left' ? scrollLeft - clientWidth : scrollLeft + clientWidth,
        behavior: 'smooth',
      });
    }
  };
  useEffect(() => {
    getPlanList();
   
    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, []);



  const getPlanList = async () => {
 
    setLoading(true);
    try {
      const response = await axios.post(url.BASE_URL + 'site/getSubscriptionPlanList');
      let plancolor = ['#EC407A','#005B77','#26c6DA','#FFC107'];
      if (response?.data?.body?.statusFlag === 1 && response?.data?.body?.planList) {
        const formattedPlans = response?.data?.body?.planList?.map((plan,index) => {
          return {
            title: ` ${plan.plan_name}`,
            price: `₹${plan.amount} / ${plan.validity_in_days} days`,
            color: plancolor[index % plancolor.length], // you can customize this
            features: plan?.feature?.split('|').map(text => ({
              text: text.trim(),
              included: true
            })),
            category_id: plan.category_id,
            plan_id: plan.plan_id,
            validity_in_days : plan.validity_in_days,
            "total_questions": plan.total_questions,
            "mark_per_question": plan.mark_per_question,
            "test_duration": plan.test_duration,
            "total_marks": plan.total_marks,
          };
        
        });
        setPlanList(formattedPlans);
        setLoading(false);

      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("student detailsAPI Error:", error);
    }
  }
  return (
    <div className="pricing-wrapper">
           
      <div className="pricing-scroll" ref={scrollRef} style={{ justifyContent: 'center' }}>
        {planList?.map((plan, idx) => (
          <div key={idx} className="pricing-card"  >
            <div
              className="pricing-ribbon"
              style={{ backgroundColor: plan?.color }}
            >
              {plan.price}
            </div>
            {Number(plan?.subCount)>0 && 
            <div
              
              style={{position:'absolute',left:-10, top:6, backgroundColor: 'green', color:'#fff', borderRadius:5, padding:'4px', width:'fit-content', fontSize:12 }}
            >
              {'Subscribed'}
            </div>}
            <h3 className="pricing-title" style={{ color: plan?.color }}>
              {plan.title}
            </h3>
            <ul className="pricing-features">
              {plan?.features?.map((feature, i) => (
                <li key={i} className={feature.included ? 'included' : 'excluded'}>
                  {feature.included ? '✔' : '✘'} {feature.text}
                </li>
              ))}
            </ul>
            <button
              className="pricing-btn"
              onClick={() => handleSubscribeClick(plan)}
              style={{ backgroundColor: plan?.color }}
            >
              SUBSCRIBE
            </button>
          </div>
        ))}
      </div>
      {/* {showScrollButtons && (
        <button className="scroll-btn right" onClick={() => scroll('right')}>&gt;</button>
      )} */}

   
    </div>

    
  );
}
